import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manutenzione',
  templateUrl: './manutenzione.component.html',
  styleUrls: ['./manutenzione.component.scss']
})
export class ManutenzioneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
